import React, { FC, useEffect, useState } from 'react';
import logo from './loading.gif';

import './index.less';

/**
 * 用于包裹组件，组件loading没完成之前就显示loading，完成了再显示内容
 */
interface IProps {
  loading: boolean;
  fallback?: JSX.Element | null;
  delay?: number;
}
const LoadingWrapper: FC<IProps> = props => {
  const [innerLoading, setInnerLoading] = useState(true);
  const {
    loading,
    delay = 100,
    fallback = <img className="c-loading-wrapper-logo" src={logo} alt="" />,
    children,
  } = props;

  useEffect(() => {
    if (!loading) {
      setTimeout(() => {
        setInnerLoading(false);
      }, delay);
    }
  }, [loading, delay]);
  return (
    <>
      {innerLoading ? (
        <div className="c-loading-wrapper">{fallback}</div>
      ) : null}
      {children}
    </>
  );
};
export default LoadingWrapper;
